import { render, staticRenderFns } from "./CrmHome.vue?vue&type=template&id=17f9213d&scoped=true&"
import script from "./CrmHome.vue?vue&type=script&lang=js&"
export * from "./CrmHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9213d",
  null
  
)

export default component.exports